import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { Container, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import BuyPermitsForm from "../Forms/buypermits/BuyPermitsForm";
import { getProfileStates } from "../../store/profile/action";
import { getUserContextData } from "../../store/login/selector";
import AddPermitPage from "./addPermitPage";
import ViewPermitCart from "./viewPermitCart";
import { getDriverPermitListStates, getDriverPermitResionText } from "../../store/permitList/action";
import {
  getBuyPermitPaymentMethods,
  getCheckoutSelectAddressStates,
  getCheckoutSelectEmailStates,
  getCheckoutSelectPhoneStates,
  hideBuyPermitUpdateVehicleModal,
  setBuyPermitEditVehicle,
  showBuyPermitUpdateVehicleModal,
} from "../../store/buyPermits/action";
import { getProfileData } from "../../store/profile/selector";
import { fetchRequiredFiled } from "../../store/ProfileRequiredField/action";
import { getDriverViewOrderStates } from "../../store/vieworder/action";

const useStyles = makeStyles((theme) => ({
  root: {
    // minHeight: "calc(100vh - 302px)",
  },
  table: {
    minWidth: 650,
  },
  searchBox: {
    margin: "30px",
  },
  searchIcon: {
    borderRadius: "45%",
  },
  rightIconsContainer: {
    position: "absolute",
    right: "20px",
    top: "10px",
  },
  toolbarContainer: {
    marginBottom: "10px",
    //width: '100%',
    position: "relative",
    padding: "10px",
  },
  txtgreen: {
    color: "#0f0",
  },
  txtbold: {},
  buy_permit_btn: {
    margin: 30,
    textAlign: "center",
  },
  innerFlex: {
    display: "flex",
  },
  dottedBorder: {
    background: "#d3d0d0",
  },
  iconColor: {
    color: "#11408e",
  },
  backgroundtheme: {
    color: theme.palette.primary.main,
  },
  headh6: {
    color: "#11408e",
    fontWeight: 600,
    marginRight: "10px",
    fontSize: "1.6rem",
  },
}));

const getDateFormetted = (dateString) => {
  let date = new Date(dateString);
  return (
    (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) +
    "/" +
    (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
    "/" +
    date.getFullYear()
  );
};

const BuyPermitsPage = (props) => {
  let location = useLocation();
  const dispatch = useDispatch();
  const [profileDataItems, SetprofileDataItems] = React.useState("");
  const [permit, setpermit] = useState([]);
  const [viewType, setviewType] = useState("grid");
  const [filters, setfilters] = useState("");
  const [search, setsearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentEdit, setcurrentEdit] = useState("");
  const profileStore = useSelector(getProfileData);
  const [toggleEditModel, settoggleEditModel] = useState();
  const { clientName } = useSelector(getProfileData);
  const [selectedPermit, setSelectedPermit] = useState(0);
  const [selectedDate, setSelectedDate] = React.useState([]);
  const [permitType, setPermitType] = React.useState("");
  const params = useParams();
  const { customer } = params;

  const permitList = useSelector(
    (state) => state.driverPermitListReducer.driverPermitListStateList
  );
  const vehicleUpdateModalState = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitUpdateVehicleModalState
  );
  const getPaymentMethodState = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitPaymentMethods
  );
  const [orderList, setorderList] = useState([]);
  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false);
  const EndUserId = useSelector(
    (state) => state?.profileState?.profileStateList?.endUserAccountEntity?.id
  );
  const driverViewOrderStateList = useSelector(
    (state) => state.driverViewOrderReducer.driverViewOrderStateList
  );

  var data = "There are no Attribute Assigned to this Driver";

  const CloseAlertModal = () => {
    setIsOpenAlertModal(false);
  };

  useEffect(() => {
    setorderList(driverViewOrderStateList);
    dispatch(setBuyPermitEditVehicle({ permit_id: 0, vehicleEditList: 0 }));
  }, [driverViewOrderStateList, profileStore]);

  const id = profileStore?.id;
  var driverStatus =
    profileStore &&
    profileStore?.endUserAccountEntity?.driverAttributes?.filter(
      (item, index) => {
        if (item?.name == "Status") {
          return item;
        }
      }
    );

    var driverBAStatus = profileStore &&  profileStore?.endUserAccountEntity &&
    profileStore?.endUserAccountEntity?.driverAttributes?.map((item => {
      if(item.name !== 'VIP'){
        return item.value
      }
    }))


  var status = Array.isArray(driverStatus) && driverStatus[0]?.value;

   let withoutUndeifne = driverBAStatus?.filter((ele)=> ele && ele !== undefined)

  function isDateGrater(date1, date2) {
    if (date1.getFullYear() >= date2.getFullYear()) {
      return true;
    } else if (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() >= date2.getMonth()
    ) {
      return true;
    } else if (
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() >= date2.getDate()
    ) {
      return true;
    }
    return false;
  }

  var PerchasedPermitList =
    Array.isArray(orderList) &&
    orderList?.filter((pmtOrder, i) => {
      let date1 = pmtOrder?.lines[0]?.item?.validEndDate;
      let orderDate = new Date(date1);
      let date2 = new Date();
      if (isDateGrater(orderDate, date2)) {
        return pmtOrder?.lines[0]?.item;
      }
    });

  var purchasedPermitListName = PerchasedPermitList?.map((elmt, ndx) => {
    return elmt?.lines;
  });

  var filteredPerchasedList = purchasedPermitListName?.map((prmt) => {
    return prmt[0]?.item.id;
  });

  useEffect(() => {
    const filteredPermit = permitList && permitList?.filter((item, i) => {
      if (filteredPerchasedList?.indexOf(item?.id) == -1) {
        return item;
      }
    });

    if (
      status === "undefined" ||
      (profileStore &&
        profileStore?.endUserAccountEntity?.driverAttributes?.length <= 0)
    ) {
      setIsOpenAlertModal(true);
    } else {
      setpermit(filteredPermit);
    }
  }, [permitList, orderList, profileStore, getPaymentMethodState]);

  const permitsForGrid = React.useMemo(() => {
    const filteredPermit =permitList && permitList?.filter((item, i) => {
      if (filteredPerchasedList?.indexOf(item?.name) == -1) {
        return item;
      }
    });

    if (
      status === "undefined" ||
      (profileStore &&
        profileStore?.endUserAccountEntity?.driverAttributes?.length <= 0)
    ) {
      setIsOpenAlertModal(true);
      return [];
    } else {
      return filteredPermit;
    }
  }, [permitList, profileStore, getPaymentMethodState]);

  useEffect(() => {
    settoggleEditModel(vehicleUpdateModalState);
  }, [vehicleUpdateModalState]);

  const profileUpdateData = useSelector(
    (state) =>
      state?.profileState?.profileStateList?.endUserAccountEntity?.person
  );
  const ProfileRequiredFields = useSelector(
    (state) => state.profileRequired.ProfileRequiredFields
  );

  const handleSort = (val) => {
    setfilters(val);
    setpermit(
      val === "" ? permitList : permitList.filter((item) => item.status === val)
    );
  };

  /** this effect will fetch profile detail from reducer   */
  useEffect(() => {
    if (profileStore && profileStore?.accountId) {
      dispatch(
        getDriverPermitListStates(profileStore && profileStore?.accountId)
      );
    }
    dispatch(getDriverPermitResionText(user?.user?.userGroup ||  profileStore?.permissionGroup))
    dispatch(getProfileStates(user?.user?.userName));
  }, [profileStore?.accountId]);

  useEffect(() => {
    if (
      status === "undefined" ||
      (profileStore &&
        profileStore?.endUserAccountEntity?.driverAttributes?.length <= 0)
    ) {
      setIsOpenAlertModal(true);
    }
  }, [profileStore]);

  /** get user  from reducer  */
  const user = useSelector(getUserContextData);
  /** get profile data from reducer  */

  const handleCloseEditModel = useCallback((permit) => {
    dispatch(hideBuyPermitUpdateVehicleModal());
  });

  const handleOpenEditModel = useCallback((permit) => {
    setSelectedPermit(permit);
    dispatch(showBuyPermitUpdateVehicleModal());
  });
  const [toggleAddPermitPage, settoggleAddPermitPage] = useState(null);

  useEffect(() => {
    settoggleAddPermitPage(location?.state?.title);
  }, [location]);

  const handletoggleAddPermitPage = useCallback((type) => {
    settoggleAddPermitPage(type);
    // dispatch(showBuyPermitsExitOrderModal())
  });

  useEffect(() => {
    if (EndUserId) {
      dispatch(getCheckoutSelectAddressStates({ accountId: EndUserId }));
      dispatch(getCheckoutSelectEmailStates({ accountId: EndUserId }));
      dispatch(getCheckoutSelectPhoneStates({ accountId: EndUserId }));
      dispatch(getDriverViewOrderStates(EndUserId));
    }
    if (
      status === "undefined" ||
      (profileStore &&
        profileStore?.endUserAccountEntity?.driverAttributes?.length <= 0)
    ) {
    } else {
      // dispatch(getBuyPermitPaymentMethods({ id: id, status: status }));
      dispatch(getBuyPermitPaymentMethods({ status: withoutUndeifne, clientUserName: user?.user?.userGroup }));
    }
  }, [EndUserId]);

  const open = Boolean(anchorEl);
  const StylingItem = props.StylingItem;

  const toggleView = (type) => {
    setviewType(type);
  };

  /* filter the array */
  const handleSearch = (e) => {
    setsearch(e.target.value);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const dateCondition = (to, from) => { };
  const dateString = (to, from) => {
    return `${getDateFormetted(to)} to ${getDateFormetted(from)}`;
  };

  useEffect(() => {
    SetprofileDataItems(profileUpdateData);
  }, [profileUpdateData]);

  /** Dispatch Required Field API  */
  useEffect(() => {
    dispatch(fetchRequiredFiled(user?.user?.userGroup || profileStore?.permissionGroup));
  }, [clientName]);
  
  const classes = useStyles();
  const stylingVal = {
    backgroundColor: StylingItem && StylingItem?.bodyColor,
    fontFamily: StylingItem && StylingItem?.font,
    color: StylingItem && StylingItem?.fontColor,
    marginTop: 12,
  };

  if (profileDataItems) {
    if (
      profileDataItems?.birthday &&
      profileDataItems?.addresses?.length > 0 &&
      profileDataItems?.emailAddresses?.length > 0 &&
      profileDataItems?.phones?.length > 0 &&
      profileDataItems?.vehicles?.length > 0 &&
      Object.keys(profileDataItems?.driversLicense || {})?.length > 0
    ) {
      return (
        <>
          {toggleAddPermitPage === "view" ? (
            <ViewPermitCart
              StylingItem={StylingItem}
              handletoggleAddPermitPage={handletoggleAddPermitPage}
              setSelectedDate={setSelectedDate}
              selectedDate={selectedDate}
              setPermitType={setPermitType}
              permitType={permitType}
            />
          ) : (
            <>
              {" "}
              <AddPermitPage
                StylingItem={StylingItem}
                selectedPermit={selectedPermit}
                handletoggleAddPermitPage={handletoggleAddPermitPage}
                setSelectedDate={setSelectedDate}
                selectedDate={selectedDate}
                setPermitType={setPermitType}
                permitType={permitType}
                allPermit={permitList}
              />
            </>
          )}
        </>
      );
    } else {
      return (
        <>
          <Grid className="permit-page-wrapper permit-bg">
            <Container maxWidth={"xl"}>
              {ProfileRequiredFields &&
                ProfileRequiredFields.list &&
                ProfileRequiredFields.list.length > 0 &&
                (
                  (ProfileRequiredFields.list[1]?.required &&
                 profileDataItems?.birthday == null)
                 ||
                  (ProfileRequiredFields.list[2]?.required &&
                    profileDataItems?.driversLicense == null)
                     ||
                  (ProfileRequiredFields.list[3]?.required &&
                    profileDataItems?.phones?.length < 1) ||
                  (ProfileRequiredFields.list[4]?.required &&
                    profileDataItems?.addresses?.length < 1)
                     ||
                  (ProfileRequiredFields.list[0]?.required &&
                    profileDataItems?.addresses?.gender === ""))
                     ? (
                <BuyPermitsForm
                  stylingVal={stylingVal}
                  inCompleteDetails={{
                    Birthday: {
                      data: profileDataItems?.birthday,
                      required: ProfileRequiredFields?.list[1]?.required,
                    },
                    Address: {
                      data: profileDataItems?.addresses?.length > 0,
                      required: ProfileRequiredFields?.list[4]?.required,
                    },
                    "Email Address": {
                      data: profileDataItems?.emailAddresses?.length > 0,
                      required: false,
                    },
                    Phones: {
                      data: profileDataItems?.phones?.length > 0,
                      required: ProfileRequiredFields?.list[3]?.required,
                    },
                    Vehicles: {
                      data: profileDataItems?.vehicles?.length > 0,
                      required: false,
                    },
                    "Driver License": {
                      data:
                        Object.keys(profileDataItems?.driversLicense || {})
                          ?.length > 0,
                      required: ProfileRequiredFields?.list[2]?.required,
                    },
                  }}
                />
              ) : (
                <>
                  {toggleAddPermitPage === "view" ? (
                    <ViewPermitCart
                      StylingItem={StylingItem}
                      handletoggleAddPermitPage={handletoggleAddPermitPage}
                      setSelectedDate={setSelectedDate}
                      selectedDate={selectedDate}
                      setPermitType={setPermitType}
                      permitType={permitType}
                    />
                  ) : (
                    <>
                      {" "}
                      <AddPermitPage
                        StylingItem={StylingItem}
                        handletoggleAddPermitPage={handletoggleAddPermitPage}
                        setSelectedDate={setSelectedDate}
                        selectedDate={selectedDate}
                        setPermitType={setPermitType}
                        permitType={permitType}
                        allPermit={permitList}
                      />
                    </>
                  )}
                </>
              )}
            </Container>
          </Grid>
        </>
      );
    }
  } else {
    return <></>;
  }
};

export default BuyPermitsPage;
